export * from './config.service';
export * from './config.provider';
export * from './config.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/config/index.ts